import { useEffect, useState } from "react";
import { siteMeta } from "@/mocks/home";

const navItems = [
  { id: "domains", label: "入口速览" },
  { id: "mirrors", label: "镜像索引" },
  { id: "updates", label: "更新日志" },
  { id: "guide", label: "防走失" },
  { id: "collections", label: "合集" },
  { id: "faq", label: "常见问题" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-8">
        <a
          href="#top"
          className={`flex items-center gap-2 cursor-pointer ${scrolled ? "text-foreground-950" : "text-white"}`}
        >
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md border ${
              scrolled ? "border-primary-300 bg-primary-50" : "border-white/40 bg-white/10"
            }`}
          >
            <i className={`ri-vip-diamond-line text-lg ${scrolled ? "text-primary-600" : "text-white"}`}></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-base tracking-wide">{siteMeta.name}</span>
            <span className={`text-[11px] mt-0.5 ${scrolled ? "text-foreground-500" : "text-white/70"}`}>
              入口索引
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 text-sm rounded-md cursor-pointer whitespace-nowrap transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                  : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#domains"
            className={`hidden sm:inline-flex items-center gap-1.5 px-4 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-white/20 text-white border border-white/30 hover:bg-white/25"
            }`}
          >
            <i className="ri-links-line"></i>
            查看最新地址
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer border ${
              scrolled ? "border-background-300 text-foreground-800" : "border-white/40 text-white"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm rounded-md bg-background-100 text-foreground-800 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}